export const TABS = {
  GENERAL: "general",
  DEPLOYMENT: "deployment"
};

export const PAGE_TITLE = "Agent settings";
